import HttpRequest from './HttpRequest'

class IndividualCreateStatusProportionsProvider extends HttpRequest {
  findAll (query) {
    return this.get('/individual-creation-status-proportions/', query)
  }
}

export default IndividualCreateStatusProportionsProvider
